export default __webpack_public_path__ + "static/slideshow-3-4e35ecb26f80d292f63b7e7eeaa50edb.png";